import { iccService } from './../services/icc/icc.service';
/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE SELECTOR TEMPLATE_URL AND CLASS NAME*/
import { Component, OnInit, OnDestroy } from '@angular/core'
import { } from '../services/icc/icc.service';
import { PubSubService } from '../service/pubSub.service';
/**
* Model import Example : 
* import { HERO } from '../models/hero.model.ts';
*/

@Component({
  selector: 'bh-inboundcallcenter',
  templateUrl: './inboundcallcenter.template.html'
})

export class inboundcallcenterComponent implements OnInit, OnDestroy {
  iccData: any = {}

  depId: any = 1003; // default main id
  depName: any = 'MAIN';
  getDataSub: any;

  servicesListArr: any = [];
  constructor(private iccService: iccService, private pubsub: PubSubService) {
  }

  ngOnInit() {
    this.getDataSub = this.pubsub.$sub('getData', (eventObject) => {
      this.getDepartmentDataByDepId();
    });
    this.getDepartmentDataByDepId();
  }

  depOptionClicked(depId) {
    this.depId = depId;
    this.getDepartmentDataByDepId();
  }

  getDepartmentDataByDepId() {
    this.iccService.getInboundCallCenterData(this.depId).then(result => {
      if (result && result[0]) {
        this.iccData = result[0];
        this.servicesListArr = this.convertObjectToArray(this.iccData['servicesList']);
        this.depName = this.iccData['department']['name'];
      } else {
        this.iccData = {};
        this.servicesListArr = [];
      }
    }, error => {
      console.log(error);
    })
  }

  convertObjectToArray(obj) {
    let tempArr = [];
    for (let i = 0; i < Object.keys(obj).length; i++) {
      let value = {};
      value[Object.keys(obj)[i]] = obj[Object.keys(obj)[i]]
      tempArr.push(obj[Object.keys(obj)[i]]);
    }
    return tempArr;
  }

  serviceListTrackBy(item) {
    return item[Object.keys(item)[0]];
  }

  ngOnDestroy() {
    this.getDataSub.unsubscribe();
  }
}



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/inboundcallcenterComponent/inboundcallcenter.component.ts